import React, { useState } from 'react'
import '../../styles/app.css'
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import { useEffect } from 'react';
import { useRef } from 'react';
import AddNewBranchModal from '../../Models/AddNewBranchModel/AddNewBranchModal';
import EditBranchModal from '../../Models/AddNewBranchModel/EditBranchModal';
import { useDispatch, useSelector } from 'react-redux';
import { AddBranch, ProfileGet, UpdateBranch } from '../../apis/api/ProfileApi';
import Cookies from "js-cookie";
import { useNavigate } from 'react-router-dom';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

export default function App() {
  const [selectedBranch, setSelectedBranch] = useState(null)
  const [searchTerm, setSearchTerm] = useState('')
  const [selectedLocation, setSelectedLocation] = useState(null);
  const markerRef = useRef(null);
  const [searchResults, setSearchResults] = useState([]);
  const [debounceTimeout, setDebounceTimeout] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const dispatch = useDispatch();
  const userId = Cookies.get("userID");
  const company_id = Cookies.get("company_id");
  const profileData = useSelector((state) => state.ProfileSlice.profileData);
  const [branches1, setBranches1] = useState([]);
  const navigate = useNavigate();





  useEffect(() => {
    dispatch(ProfileGet({ userId, company_id }))
  }, [dispatch])

  useEffect(() => {
    if (profileData?.data?.branches?.length > 0) {
      setBranches1(profileData.data.branches);
      setSelectedBranch(profileData.data.branches[0]);
      setSelectedLocation(profileData.data.branches[0].city);
      console.log("Branch: ", profileData.data.branches);
    }
  }, [profileData]);

  useEffect(() => {
    if (branches1?.length > 0) {
      setSearchResults(branches1);
    }
    console.log(branches1)
  }, [branches1]);






  const getStatusColor = (status) => {
    switch (status) {
      case 'online': return 'success'
      case 'warning': return 'warning'
      default: return 'secondary'
    }
  }

  const [map, setMap] = useState(null);


  useEffect(() => {
    if (!map && branches1 && branches1.length > 0) {
      const mapInstance = L.map("map").setView([20, 77], 4);
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: "&copy; OpenStreetMap contributors",
      }).addTo(mapInstance);

      setMap(mapInstance);

      setTimeout(() => {
      mapInstance.invalidateSize();
    }, 200);
    }
  }, [map, branches1]);

  useEffect(() => {
    if (map && selectedLocation) {

      fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${selectedLocation}`
      )
        .then((res) => res.json())
        .then((data) => {
          if (data && data.length > 0) {
            const { lat, lon } = data[0];


            map.setView([lat, lon], 5);

            if (markerRef.current) {
              map.removeLayer(markerRef.current);
            }


            const newMarker = L.marker([lat, lon])
              .addTo(map)
              .bindPopup(`<b>${selectedLocation}</b>`)
              .openPopup();

            markerRef.current = newMarker;
          }
        })
        .catch((err) => console.error("Error fetching location:", err));
    }
  }, [map, selectedLocation]);



  useEffect(() => {
    if (searchTerm === "") {
      setSearchResults(branches1);
      return;
    }

    if (debounceTimeout)
      clearTimeout(debounceTimeout);
    console.log(searchTerm);
    const timeout = setTimeout(() => {
      const filtered = branches1.filter((branch) => {
        return branch.city.toLowerCase().startsWith(searchTerm.toLowerCase());
      })
      console.log(filtered);
      setSearchResults(filtered);
    }, 500);

    setDebounceTimeout(timeout);

    return () => { clearTimeout(timeout) }

  }, [searchTerm])


  const handleAddBranch = (formData) => {


    const payload = {
      ...formData,
      company_id,
      userId,
    };

    dispatch(AddBranch(payload))
      .unwrap()
      .then((res) => {
        console.log("Branch added:", res);
        navigate("/branches");
      })
      .catch((err) => {
        console.error("Error adding branch:", err);
      });
    dispatch(ProfileGet({ userId, company_id }))
  };


  const handleEditBranch = (formData) => {
    const payload = {
      ...formData,
      id: selectedBranch?.id,
      company_id,
      userId,
    };

    dispatch(UpdateBranch(payload))
      .unwrap()
      .then((res) => {
        console.log("Branch updated:", res);
        navigate("/branches");
      })
      .catch((err) => {
        console.error("Error updating branch:", err);
      });
    dispatch(ProfileGet({ userId, company_id }))
  }


  const selectedBranchData = branches1.find(branch => branch.id === selectedBranch?.id)

  return (
    <>

      <div className="branch-mgmt-container-fluid vh-100">
        <div className="row h-100">
          {/* Left Sidebar - Branch List */}
          <div className="col-md-4 col-lg-4 branch-mgmt-sidebar p-0">
            <div className="p-3">
              <div className="d-flex align-items-center mb-3">
                <i className="bx bx-building-house text-primary me-2 fs-5"></i>
                <h6 className="mb-0 fw-bold">Branches</h6>
              </div>

              {/* Add New Branch Button */}
              <div className="mb-3">
                <button className="btn btn-dark w-100 branch-mgmt-add-btn p-2" onClick={() => setShowAddModal(true)}>
                  <i className="bx bx-plus me-2"></i>
                  Add New Branch
                </button>
              </div>


              {/* Search Bar */}
              <div className="mb-3">
                <div className="input-group">
                  <span className="input-group-text bg-transparent border-end-0">
                    <i className="bx bx-search text-muted"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control border-start-0 branch-mgmt-search-input"
                    placeholder="Search branches..."
                    value={searchTerm}
                    onChange={(e) => { setSearchTerm(e.target.value); }}
                  />
                </div>
              </div>

              {/* Branch Count */}
              <div className="d-flex align-items-center mb-3 text-muted small">
                <span>{selectedBranch?.country} Branches</span>
                <span className="badge bg-secondary ms-auto">{searchResults?.length}</span>
              </div>

              {/* Branch List */}
              <div className="branch-mgmt-branch-list">
                {searchResults.map((branch) => (
                  <div
                    key={branch.id}
                    className={`branch-mgmt-list-item ${selectedBranch.id === branch.id ? 'branch-mgmt-active' : ''}`}
                    onClick={() => { setSelectedBranch(branch); setSelectedLocation(branch.city) }}
                    style={{ cursor: 'pointer' }}
                  >
                    <div className="d-flex align-items-center">
                      <i className="bx bx-building text-primary me-3"></i>
                      <div className="flex-grow-1">
                        <div className="fw-semibold">{branch.main_branch === 1 ? "Head Office" : `${branch.city} Office`}</div>
                        <div className="small text-muted d-flex align-items-center">
                          <i className="bx bx-map-pin me-1"></i>
                          {branch.city}
                          <i className="bx bx-star-half ms-2 me-1 text-warning"></i>
                          {/* {branch.rating || 4} */}
                        </div>
                      </div>
                      <span className={`badge bg-${getStatusColor(branch.status)} branch-mgmt-status-badge`}></span>
                    </div>
                  </div>
                ))}

                {searchResults.length === 0 && (
                  <div className="text-center text-muted py-4">
                    <i className="bx bx-search fs-2 mb-2"></i>
                    <div>No branches found</div>
                  </div>
                )}
              </div>
            </div>
          </div>


          {/* Main Content */}
          <div className="col-md-8 col-lg-8 p-0">
            <div className="branch-mgmt-content-wrapper">
              {branches1.length < 1 ? (
                // Show this if no branches
                <div className="d-flex flex-column align-items-center justify-content-center h-100 text-muted">
                  <i className="bx bx-building-house fs-1 mb-3"></i>
                  <h5>No branch details to show</h5>
                  <p className="small">Please add a branch to see its details here.</p>
                </div>
              ) : (
                <>
                  {/* Header */}
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <div>
                      <h2 className="mb-0">Branch Details</h2>
                      <p className="text-muted mb-0">{`${selectedBranch?.main_branch === 1 ? "Head Office" : ""} | ${selectedBranch?.city} Branch`}</p>
                    </div>
                    <div>
                      <button className="btn btn-outline-secondary me-2 branch-mgmt-back-btn" onClick={() => navigate(-1)}>
                        <i className="bx bx-arrow-back me-2"></i>
                        Back
                      </button>
                      <button className="btn btn-dark branch-mgmt-edit-btn" onClick={() => {console.log(selectedBranchData.email, "TS"); setShowEditModal(true)}}>
                        <i className="bx bx-edit me-2"></i>
                        Edit
                      </button>
                    </div>
                  </div>

                  {/* Single Column Layout */}
                  <div className="row">
                    <div className="col-12">
                      {/* Branch Information */}
                      <div id="branch-info" className="card mb-4 branch-mgmt-info-card">
                        <div className="card-body">
                          <div className="d-flex align-items-center mb-3">
                            <i className="bx bx-building text-primary me-2 fs-5"></i>
                            <h5 className="mb-0">Branch Information</h5>
                          </div>

                          <div className="row">
                            <div className="col-md-6">
                              <div className="mb-3">
                                <div className="d-flex align-items-center mb-2">
                                  <i className="bx bx-map text-primary me-2"></i>
                                  <span className="text-muted me-1">Address:</span>
                                  {`${selectedBranch?.address}`}
                                </div>
                              </div>

                              <div className="mb-3">
                                <div className="d-flex align-items-center mb-2">
                                  <i className="bx bx-envelope text-primary me-2"></i>
                                  <span className="text-muted me-1">Email:</span>
                                  {selectedBranch?.email}
                                </div>
                              </div>


                            </div>

                            <div className="col-md-6">
                              <div className="mb-3">
                                <div className="d-flex align-items-center mb-2">
                                  <i className="bx bx-map text-primary me-2"></i>
                                  <span className="text-muted me-1">City:</span>
                                  {selectedBranch?.city}
                                </div>
                              </div>

                              <div className="mb-3">
                                <div className="d-flex align-items-center mb-2">
                                  <i className="bx bx-phone text-primary me-2"></i>
                                  <span className="text-muted me-1">Phone Number:</span>
                                  {selectedBranch?.contact}
                                </div>
                              </div>


                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Branch Statistics */}
                      {/* <div id="branch-stats" className="card mb-4 branch-mgmt-stats-card">
                    <div className="card-body">
                      <div className="d-flex align-items-center mb-3">
                        <i className="bx bx-group text-primary me-2 fs-5"></i>
                        <h5 className="mb-0">Branch Statistics</h5>
                      </div>

                      <div className="row d-flex align-items-stretch">
                        <div className="col-md-4 d-flex">
                          <div className="bg-light p-3 rounded branch-mgmt-stats-item mb-3 h-100 w-100 d-flex flex-column justify-content-center">
                            <div className="d-flex align-items-center">
                              <i className="bx bx-group text-primary me-2"></i>
                              <div>
                                <div className="fw-bold fs-4">156</div>
                                <small className="text-muted">Active Members</small>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-4 d-flex">
                          <div className="bg-light p-3 rounded branch-mgmt-stats-item mb-3 h-100 w-100 d-flex flex-column justify-content-center">
                            <div className="d-flex align-items-center">
                              <i className="bx bx-calendar text-success me-2"></i>
                              <div>
                                <div className="fw-bold fs-4">24</div>
                                <small className="text-muted">Events This Month</small>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-4 d-flex">
                          <div className="bg-light p-3 rounded branch-mgmt-stats-item mb-3 h-100 w-100 d-flex flex-column justify-content-center">
                            <div className="d-flex align-items-center">
                              <i className="bx bx-star text-warning me-2"></i>
                              <div>
                                <div className="fw-bold fs-4">{selectedBranchData?.rating}</div>
                                <small className="text-muted">Average Rating</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>


                    </div>
                  </div> */}

                      {/* Location */}
                      <div id="branch-location" className="card mb-4 branch-mgmt-location-card">
                        <div className="card-body">
                          <div className="d-flex align-items-center mb-3">
                            <i className="bx bx-location-plus text-primary me-2 fs-5"></i>
                            <h5 className="mb-0">Location</h5>
                          </div>

                          <div className="position-relative bg-light rounded p-4 text-center branch-mgmt-map-container" style={{ minHeight: '400px' }}>

                            <div className="d-flex flex-column align-items-center justify-content-center branch-mgmt-map-placeholder" style={{ height: '300px' }}>
                              <div
                                id="map"
                                style={{ height: "100%", width: "100%", borderRadius: "10px" }}
                                className="shadow-sm"
                              ></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <AddNewBranchModal
        show={showAddModal}
        country={profileData?.data?.company_data?.country || ""}
        onHide={() => setShowAddModal(false)}
        onSubmit={handleAddBranch}
      />

      <EditBranchModal
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        onSubmit={handleEditBranch}
        oldEmail= {selectedBranchData?.email}
        branchData={selectedBranchData}
      />
    </>
  )
}
